import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { registerStepSelector } from "store/user/auth/user_auth.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const FLOWS = {
  REGISTER: "register",
  VERIFY: "verify",
};

export const useFlow = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [flow, setFlow] = useState(FLOWS.REGISTER);
  // -------------------------- REDUX ---------------------------
  const step = useSelector(registerStepSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (step === 0) {
      setFlow(FLOWS.REGISTER);
    }
    if (step === 1) {
      setFlow(FLOWS.VERIFY);
    }
  }, [step]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
